const isTrue = (value) => {
	return `${value}`.toLowerCase() === 'true'
}

PLATFORM      = (typeof document !== 'undefined') ? 'web': ((typeof navigator !== 'undefined' && navigator.product === 'ReactNative')? 'mobile': 'server');
__SERVER__    = (typeof window === "undefined");
__window__    = typeof window !== "undefined" ? window : null;
__document__  = typeof document !== "undefined" ? document : null;
__LOGGER_NAME__ = typeof window !== 'undefined' ? 'frontend' : 'backend';
__PORT__        = null;
__SERVER_PORT__ = process.env.NEXT_PUBLIC_SERVER_PORT || process.env.NEXT_PUBLIC_PORT || 3000;
__WEBSITE_URL__ = process.env.NEXT_PUBLIC_WEBSITE_URL || '/graphql';
__API_URL__     = process.env.API_URL || process.env.NEXT_PUBLIC_API_URL || '/graphql';
__API_SERVER__	= process.env.API_SERVER || process.env.NEXT_PUBLIC_API_SERVER || '/api/graphql';

__DISABLE_SLUG__        = isTrue(process.env.NEXT_PUBLIC_DISABLE_SLUG)

__DOMAIN_COOKIE_ALL__   = isTrue(process.env.NEXT_PUBLIC_DOMAIN_COOKIE_ALL)

__MAX_AGE__             = isTrue(process.env.NEXT_PUBLIC_MAX_AGE)
__LANG_ENABLED__        = isTrue(process.env.NEXT_PUBLIC_LANG_ENABLED)
__LANG_PICKER_RENDER__  = isTrue(process.env.NEXT_PUBLIC_LANG_PICKER_RENDER)
__LANG_LIST__           = process.env.NEXT_PUBLIC_LANG_LIST
__LANG_COOKIE__         = process.env.NEXT_PUBLIC_LANG_COOKIE
__LANG_INIT_FALLBACK__  = process.env.NEXT_PUBLIC_LANG_INIT_FALLBACK

__LANG_INIT_LNG__           = process.env.NEXT_PUBLIC_LANG_INIT_LNG
__LANG_INIT_DEFAULT_NS__    = process.env.NEXT_PUBLIC_LANG_INIT_DEFAULT_NS
__LANG_INIT_NS_SEPARATOR__  = process.env.NEXT_PUBLIC_LANG_INIT_NS_SEPARATOR


__DEV__         = process.env.NEXT_PUBLIC_NODE_ENV !== 'production';
__DEBUG__       = __DEV__ && (`${process.env.DEBUG}`.toUpperCase() === 'TRUE');
__TEST_STRING__ = null;
__TEST__        = process.env.__TEST__ || false;
__SSR__         = process.env.__SSR__ || true;
